import { createServerFn } from "@tanstack/react-start"
import { readViewportHint } from "@/lib/viewport-hint.server"

// A server-rendered page can't measure the screen, so layouts that switch on
// width (the guide view: map beside the text at lg+, map behind a sheet below)
// would always render the narrow layout on the server and jump on desktop once
// the browser measured. This guesses from the request instead, the browser's
// first render reuses the same guess (so hydration matches), and the real
// width corrects it afterwards — a visible switch only when the guess was wrong
// (e.g. an iPad in landscape, which reports a desktop user agent).

// true = "probably a wide (desktop) screen". The Client Hint wins when the
// browser sends it; otherwise the classic mobile user-agent tokens.
export function guessWideViewport(
  userAgent: string | undefined,
  chUaMobile: string | undefined
): boolean {
  if (chUaMobile === `?1`) return false
  if (chUaMobile === `?0`) return true
  return !/Mobi|Android|iPhone|iPod/i.test(userAgent ?? ``)
}

export const fetchViewportHint = createServerFn({ method: `GET` }).handler(
  async (): Promise<boolean> => readViewportHint()
)
